export enum PaymentTo {
  viapitchin = 1,
  direct = 2,
}
